import React from 'react';
import './PolicyTotalitarianismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";
import {
  POLICY_TOTALITARIANISM_BUILDING_DISCOUNT_ARSENAL_AND_MILITARY_CAMP,
  POLICY_TOTALITARIANISM_MILITARY_BUILDINGS_WIN_POINTS_RATIO,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D10,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D12,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D20,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D8
} from "../../../../configs/policy/totalitarianism";

const PolicyTotalitarianismDescription = () => {
  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  const arsenal = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/arsenal.7f5423b5.png'}
    alt={'Арсенал'}
    title={'Арсенал'}
  />;
  const arsenalMarginRight = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/arsenal.7f5423b5.png'}
    alt={'Арсенал'}
    title={'Арсенал'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const unitSize = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const buildingDiscount =
    <CoinsStat
      text={POLICY_TOTALITARIANISM_BUILDING_DISCOUNT_ARSENAL_AND_MILITARY_CAMP}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const winPoints = <WinPointsStat
    text={1}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  return (
    <>
      <div className={'policy-description_line'}>
        Доход {winPoints}
      </div>
      <div className={'policy-description_line'}>
        за каждые {POLICY_TOTALITARIANISM_MILITARY_BUILDINGS_WIN_POINTS_RATIO} {barracks}{militaryCamp}{arsenal}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        {militaryCamp}{arsenalMarginRight} дешевле {discountElement} на {buildingDiscount}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Отряды нанимаются сразу с {unitSize}:
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d10 friend.png'}
          alt={'Отряд Тяжелая Пехота (макс. размер 10)'}
          title={'Отряд Тяжелая Пехота (макс. размер 10)'}
        />
        <span>
          {POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D10}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d20 friend.png'}
          alt={'Отряд Элитная Пехота (макс. размер 20)'}
          title={'Отряд Элитная Пехота (макс. размер 20)'}
        />
        <span>
          {POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D20}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d8 friend.png'}
          alt={'Отряд Легкая Кавалерия (макс. размер 8)'}
          title={'Отряд Легкая Кавалерия (макс. размер 8)'}
        />
        <span>
          {POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D8}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d12 friend.png'}
          alt={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
          title={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
        />
        <span>
          {POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D12}
        </span>
        .
      </div>
    </>
  );
};

export default PolicyTotalitarianismDescription;
